import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import useSchema from '../hooks/useSchema'
import { rootRoute } from './root'

const Casino = lazyRouteComponent(() => import('../pages/casino'))

const homeNavigationSchema = `<script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      "name": "Fun88 Mexico",
      "url": "https://www.fun88mx.mx/",
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://www.fun88mx.mx/search?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Iniciar Sesión",
      "url": "https://www.fun88mx.mx/login"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Registrarse",
      "url": "https://www.fun88mx.mx/register"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Descargar App",
      "url": "https://www.fun88mx.mx/app"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Apuestas Deportivas",
      "url": "https://www.fun88mx.mx/sports"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Casino en Vivo",
      "url": "https://www.fun88mx.mx/live-casino"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Promociones",
      "url": "https://www.fun88mx.mx/promotions"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Mundial 2026",
      "url": "https://www.fun88mx.mx/world-cup-2026"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Soporte",
      "url": "https://www.fun88mx.mx/support"
    },
    {
      "@type": "SiteNavigationElement",
      "name": "Juego Responsable",
      "url": "https://www.fun88mx.mx/responsible-gaming"
    }
  ]
}
</script>`

const homeSchemas = [homeNavigationSchema]

const IndexPage = () => {
  useSchema(homeSchemas)

  return <Casino category="inicio" />
}

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: IndexPage,
})
